<template>
    <div>
        <rkm-row>
            <rkm-col
                v-for="fatorRisco in fatoresRisco"
                v-bind:key="fatorRisco.id"
                cols="6"
            >
                <rkm-form-checkbox
                    :value="fatorRisco.id"
                    class="text-nowrap"
                    inline
                    onchange=""
                    v-model="data.model.fatoresRisco"
                >
                    {{ fatorRisco.nome }}
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-2">
            <rkm-col>
                <rkm-form-input
                    v-if="data.model.fatoresRisco.find(item => item === enums.fatorRisco.OUTRO)"
                    :validations="validations.outro"
                    label="Outro"
                    v-model="data.model.fatorRiscoOutro"
                />
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>

// Enums.
import fatorRisco from '@/enums/pronto-atendimento/observacao/fator-risco'
import sexo from '@/enums/cadastro/cidadao/sexo'

export default {
    computed: {
        validations() {
            return {
                outro: {
                    required: true,
                    max: 100,
                },
            }
        },
        fatoresRisco(){

            if(this.data.model.exibirFatorRiscoGestante == true){

                return this.data.form.fatoresRiscoGestante
            } else {

                return this.data.form.fatoresRisco
            }
        }
    },
    data: () => ({
        enums: {
            fatorRisco,
            sexo,
        },
    }),
    props: {
        data: { type: Object, required: true },
    },
}
</script>